module.exports = __webpack_public_path__ + "static/4-bc3aa95dca08f5fee5291e34959c27bc.woff2";